module.exports = __webpack_public_path__ + "static/button-mobile-standard-nav-do-a4306637d79d5395403df6dbc316d0d8.png";